const baseTheme = () => {
    return {
        palette: {
            primary: {
                main: '#0b583c',
                hover: '#1c6d25'
            }
        }
    };
};
const themeDependent = (theme) => {
    return null;
};

export default {
    baseTheme,
    themeDependent
};